'use client';

import React from 'react';
import { useIntl } from 'react-intl';
import clsx from 'clsx';

import SectionTitle from '../theme/SectionTitle';
import { AddressInfo } from './components/AddressInfo';
import { PropertyMap } from './components/PropertyMap';
import { useMapsNavigation } from './hooks/useMapsNavigation';

import styles from './index.module.scss';
import { Settings } from '@/models';

type AddressProps = {
  propertyName: string;
  address: Settings['property']['address'];
  mobileOnly?: boolean;
  primaryColor: string;
};

export const Address = ({
  propertyName,
  address,
  mobileOnly,
  primaryColor,
}: AddressProps) => {
  const intl = useIntl();
  const showMap = !!(address?.latitude && address?.longitude);
  const { openMaps } = useMapsNavigation({ address });

  if (!address) {
    return null;
  }

  const { latitude, longitude } = address;

  return (
    <div
      className={clsx([styles.container, { [styles.mobileOnly]: mobileOnly }])}
    >
      <SectionTitle>
        {intl.formatMessage({
          id: 'address',
          defaultMessage: 'Address',
        })}
      </SectionTitle>

      <AddressInfo
        address={address}
        primaryColor={primaryColor}
        onOpenMaps={openMaps}
      />

      {showMap && (
        <PropertyMap
          latitude={latitude}
          longitude={longitude}
          propertyName={propertyName}
        />
      )}
    </div>
  );
};
